import React, { Component } from 'react'
import {
  Form,
  Select,
  Input,
  Divider,
  Header,
  TextArea
} from 'semantic-ui-react'

export default class CheckoutShipping extends Component {
  state = {}

  render() {
    const {
      addressOpts,
      handleAddressChange,
      handleChange,
      submitOrder,
      streetAddress,
      unit,
      city,
      province,
      country,
      postalCode,
      phone,
      email
    } = this.props
    return (
      <Form onSubmit={submitOrder} style={{ padding: 10 }}>
        <Header as="h3">Shipping Information</Header>
        <Divider />
        <Form.Group widths="equal">
          <Form.Field
            label="Select Address"
            control={Select}
            search
            options={addressOpts}
            placeholder="Select Address"
            onChange={handleAddressChange}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field
            name="streetAddress"
            label="Street Address"
            control={Input}
            value={streetAddress}
            readOnly
          />
          <Form.Field
            name="unit"
            label="Unit"
            control={Input}
            value={unit}
            width={4}
            readOnly
          />
          <Form.Field
            name="postalCode"
            label="Postal Code"
            control={Input}
            value={postalCode}
            width={5}
            readOnly
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field
            name="city"
            label="City"
            control={Input}
            value={city}
            readOnly
          />
          <Form.Field
            name="province"
            label="Province"
            control={Input}
            value={province}
            readOnly
          />
          <Form.Field
            name="country"
            label="Country"
            control={Input}
            value={country}
            readOnly
          />
        </Form.Group>
        <small>
          If an address appears incorrect or does not exist, please contact your
          Administrator.
        </small>
        <Header as="h3">Contact Information</Header>
        <Divider />
        <Form.Group widths="equal">
          <Form.Field
            name="email"
            label="Email"
            placeholder="Email"
            type="email"
            control={Input}
            value={email}
            onChange={handleChange}
          />
          <Form.Field
            name="phoneNumber"
            label="Phone Number"
            placeholder="Phone Number"
            control={Input}
            defaultValue={phone}
            onChange={handleChange}
          />
        </Form.Group>
        <Header as="h3">Order Comments</Header>
        <Divider />
        <Form.Group widths="equal">
          <Form.Field
            name="comments"
            label="Comments"
            placeholder="Enter any comments / special instructions..."
            control={TextArea}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group>
          <Form.Button
            content="Submit Order"
            color="red"
            floated="right"
            disabled={!streetAddress}
            onClick={submitOrder}
            type="submit"
          />
        </Form.Group>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckoutShipping.jsx